import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@pacifico/environments/environment';
import { TokenService } from '@pacifico/services/api/token.service';
import { LoaderService } from '@pacifico/services/local/my-loader.service';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';
import { EMPTY } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { AUTH_LOGIN, AUTH_LOGOUT } from './../services/api/endpoint-api';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
	constructor(private _router: Router, private tokenService: TokenService, private _loaderService: LoaderService) {}

	intercept(req: HttpRequest<HttpClient>, next: HttpHandler): Observable<HttpEvent<HttpClient>> {
		if (!this._urlWithinWhitelist(req.url)) {
			this._loaderService.reset();
			this._loaderService.clearParameters();
		}

		if (this._urlWithinWhitelist(req.url) && !(req.url.search('refresh') > -1)) {
			return next.handle(this._addToken(req, false));
		} else if (!this.tokenService.isLoggedIn()) {
			void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
			return EMPTY;
		}

		return next.handle(this._addToken(req, true));
	}

	/**
	 *  En esta función deberan de agregar aquellas url que no necesiten los headers de x_auth_token y sessionId
	 * @param url
	 * @returns
	 */
	private _urlWithinWhitelist(url: string): boolean {
		return (
			(url.search(AUTH_LOGIN) > -1 ||
				url.search(AUTH_LOGOUT) > -1 ||
				url.search('validateUserPacinet') > -1 ||
				url.search('validateUserAnswersPacinet') > -1 ||
				url.search('updatepasswordRecovery') > -1) &&
			!url.includes('registerdevice')
		);
	}

	/**
	 * Esta función retorna un objeto de tipo HttpRequest teniendo en cuenta que 'headers' agregar; por defecto todos los enpoint necesitan los headers de 'content-type' y 'x-api-key'
	 * @param request
	 * @param addHeaderAuth
	 * @returns
	 */
	private _addToken(request: HttpRequest<HttpClient>, addHeaderAuth: boolean): HttpRequest<HttpClient> {
		let headers = request.headers;
		if (headers) {
			headers = new HttpHeaders();
		}

		headers = headers.set('content-type', 'application/json').set('x-api-key', environment.apiKey);

		if (addHeaderAuth) {
			headers = headers.set('x_auth_token', this.tokenService.getToken());
			headers = headers.set('X-AUTH-TOKEN', this.tokenService.getSessionID());

			if (request.headers.get('X-CP-IdTransaccion')) {
				headers = headers.set('X-CP-IdTransaccion', request.headers.get('X-CP-IdTransaccion')!);
			}

			if (request.headers.get('X-CP-Origen')) {
				headers = headers.set('X-CP-Origen', request.headers.get('X-CP-Origen')!);
			}
		}

		return request.clone({
			headers
		});
	}
}
